module.exports = __webpack_public_path__ + "img/goal-ten-en.25b8202f.png";